
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"900","height":"600","viewBox":"0 0 72 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 48V0h72z","fill":"#1eb53a"}}),_c('path',{attrs:{"d":"M0 48h72V0z","fill":"#00a3dd"}}),_c('path',{attrs:{"d":"M0 48L72 0","stroke":"#fcd116","stroke-width":"19"}}),_c('path',{attrs:{"d":"M0 48L72 0","stroke":"#000","stroke-width":"13"}})])
          )
        }
      }
    